module.exports = __webpack_public_path__ + "static/media/no-image-placeholder.bac728e3.jpg";